// Configuración del backend
const baseUrl = 'https://backend.yourpack.us';

const config = {
  REACT_APP_BASE_URL: baseUrl,
  REACT_ASSETS_BASE_URL: baseUrl,
  REACT_NODE_BASE_URL: baseUrl,
  PAYPAL_CLIENT_ID: 'Af4xHVR4YfK-3n9JIe6RVe3H13peDYHUwrq100OXl68yvIz_f8aiRMj_mcsWvLvk9R8PKaDk-bli_0pS',
};

export default config;
